import React, { useContext } from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { Stack, Button, Chip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ModalContext } from '../../contexts/modal';
import PerformaDetailsForm from '../sales/performa-details-form';
import { toPersianDate, toPersianNumber } from '../../utils/helpers';
import { useGetProformas } from '../../api/hooks/sales';
import DICTIONARY from '../../utils/dictionary';

export default function ProformasTable({ onlyActives }) {
  // const [page, setPage] = React.useState(0);
  const { data: proformas } = useGetProformas(onlyActives, 0);

  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {proformas?.map((row, i) => {
              return (
                <TableRow hover tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
const colors = {
  PENDING: 'info',
  REJECTED: 'error',
  APPROVED: 'success',
  COMPLETED: 'info',
};

const columns = [
  {
    id: 'number',
    label: 'شماره',
    minWidth: 70,
    format: toPersianNumber,
  },
  { id: 'seller', label: 'فروشنده', minWidth: 70, format: (seller) => seller.name },
  { id: 'buyer', label: 'خریدار', minWidth: 70, format: (buyer) => buyer.name },
  { id: 'createdAt', label: 'تاریخ ثبت', minWidth: 70, format: toPersianDate },
  {
    id: 'status',
    label: 'وضعیت',
    minWidth: 70,
    align: 'center',
    format: (s) => <Chip label={DICTIONARY[s]} size="small" color={colors[s]} variant="outlined" />,
  },
  {
    id: 'id',
    label: 'جزئیات',
    minWidth: 70,
    format: (id) => {
      const { setOpen, setContent, setTitle } = useContext(ModalContext);

      function openLabelingModal() {
        setContent(<PerformaDetailsForm id={id} onClose={() => setOpen(false)} />);
        setTitle('جزئیات سفارش');
        setOpen(true);
      }

      return (
        <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-around">
          <Button endIcon={<OpenInNewIcon />} onClick={openLabelingModal}>
            مشاهده
          </Button>
        </Stack>
      );
    },
  },
];
